import _has from "lodash/has";

var selectObjectValueBasedOnState = function selectObjectValueBasedOnState(object, state, defaultValue) {
  var status = state.status,
      withinThreshold = state.withinThreshold;
  var fullStatus = withinThreshold && "".concat(state.status, "WithinThreshold");

  if (fullStatus && _has(object, fullStatus)) {
    return object[fullStatus];
  }

  if (_has(object, status)) {
    return object[status];
  }

  return defaultValue;
};

export default selectObjectValueBasedOnState;